document.addEventListener('DOMContentLoaded', function () {
    // console.log('Home search script initialized.');

    // Update the hidden input after a pill click (single-select within each group)
    function updateStatusInput(clickedPill) {
        const pillsContainer = clickedPill.closest('.filter-pills');
        if (!pillsContainer) return;

        // Find the hidden input for this pill group
        const statusInput = pillsContainer.querySelector('input[type="hidden"]');
        if (!statusInput) return;

        const isAlreadyActive = clickedPill.classList.contains('active');

        // Deactivate all pills in this group (single-select)
        pillsContainer.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));

        // Toggle: if it wasn't active before, activate it; if it was, leave all deselected
        if (!isAlreadyActive) {
            clickedPill.classList.add('active');
            statusInput.value = clickedPill.dataset.value;
        } else {
            statusInput.value = '';
        }

        // console.log('Status updated for search:', statusInput.value);
    }

    // Event delegation on the document to catch all pill clicks in .search-container
    document.addEventListener('click', function (e) {
        const pill = e.target.closest('.pill');
        if (!pill) return;
        if (!pill.closest('.search-container')) return;

        e.preventDefault();
        e.stopPropagation();

        updateStatusInput(pill);
    });
    // Form Validation & Redirection
    const searchForm = document.querySelector('.search-container form');
    if (searchForm) {
        searchForm.addEventListener('submit', function (e) {
            const minPrice = parseInt(this.querySelector('select[name="min_price"]').value) || 0;
            const maxPrice = parseInt(this.querySelector('select[name="max_price"]').value) || Infinity;

            if (minPrice > 0 && maxPrice > 0 && minPrice > maxPrice) {
                e.preventDefault();
                alert('Minimum price cannot be greater than maximum price.');
                return;
            }

            // Redirect based on status
            const statusInput = this.querySelector('input[name="property_status"]');
            const status = statusInput ? statusInput.value : '';
            
            // Use localized home_url if available to support subdirectory installations
            let baseUrl = (typeof reim_ajax !== 'undefined' && reim_ajax.home_url) 
                ? reim_ajax.home_url 
                : (this.getAttribute('action') || window.location.origin);
            
            // Normalize trailing slash
            baseUrl = baseUrl.replace(/\/$/, "");

            if (status === 'ready-to-occupy') {
                this.action = baseUrl + '/ready-to-occupy/';
            } else if (status === 'off-plan') {
                this.action = baseUrl + '/off-plan-2/'; 
            } else if (status === 'leasing') {
                this.action = baseUrl + '/leasing/';
            } else {
                // If no status is selected, redirect to the general property archive page
                // Only append if it's not already on the property page
                if (!baseUrl.endsWith('/property')) {
                    this.action = baseUrl + '/property/';
                } else {
                    this.action = baseUrl + '/';
                }
            }
        });
    }
});
